import useApiActions from "../../../recoil/api";

const usePresetActions = () => {
  const { getWithToken, postWithToken, putWithToken } = useApiActions();

  return { fetchPresetList, createPreset, modifyPreset };

  async function fetchPresetList(params) {
    const res = await getWithToken("admin/question/presetList", params);

    return res;
  }

  async function createPreset(params) {
    const res = await postWithToken("admin/question/presetList", params);

    return res;
  }

  async function modifyPreset(params) {
    const res = await putWithToken("admin/question/presetList", params);

    return res;
  }
};

export default usePresetActions;
